import { createAction, props } from '@ngrx/store';
import { MenuTheme } from 'src/app/shared/models';

export const OpenMenu = createAction('[Nav] Open menu');
export const CloseMenu = createAction('[Nav] Close menu');
export const ToggleMenu = createAction('[Nav] Toggle menu');

export const SetMenuTheme = createAction('[Nav] Set menu theme', (theme: MenuTheme) => ({ theme }));
export const ResetMenuTheme = createAction('[Nav] Reset menu theme');
